import { filterOptions } from '@/utils/query-base'
import { formatSapDate, formatSapTime } from '@/mixins/index'
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export default {
  'partner': {
    title: '客户编码',
    type: 'dialog',
    dialog: {
      component: 'ClientSelect',
      title: '客户编码'
    },
    width: 250
  },

  'name_org1': {
    title: '客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'change_number': {
    title: '变更次数',
    type: 'number'
  },
  'c_zzfld000016_1': {
    title: '原始客户类型编码',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'c_zzfld000016_text_1': {
    title: '原始客户类型描述',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'c_changin_date_1': {
    title: '原始创建日期',
    type: 'date',
    equation: all,
    width: 200,
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  },
  'c_changin_time_1': {
    title: '原始创建时间',
    type: 'date',
    equation: all,
    width: 200,
    formatter: ({ cellValue }) => formatSapTime(cellValue)
  },
  'c_zzfld000016_2': {
    title: '第一次变更客户类型编码',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'c_zzfld000016_text_2': {
    title: '第一次变更客户类型描述',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'c_changin_date_2': {
    title: '第一次变更日期',
    type: 'date',
    equation: all,
    width: 200,
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  },
  'c_changin_time_2': {
    title: '第一次变更时间',
    type: 'date',
    equation: all,
    width: 200,
    formatter: ({ cellValue }) => formatSapTime(cellValue)
  },
  'c_zzfld000016_3': {
    title: '第二次变更客户类型编码',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'c_zzfld000016_text_3': {
    title: '第二次变更客户类型描述',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'c_changin_date_3': {
    title: '第二次变更日期',
    type: 'date',
    equation: all,
    width: 200,
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  },
  'c_changin_time_3': {
    title: '第二次变更时间',
    type: 'date',
    equation: all,
    width: 200,
    formatter: ({ cellValue }) => formatSapTime(cellValue)
  },
  'c_zzfld000016_4': {
    title: '第三次变更客户类型编码',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'c_zzfld000016_text_4': {
    title: '第三次变更客户类型描述',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'c_changin_date_4': {
    title: '第三次变更日期',
    type: 'date',
    equation: all,
    width: 200,
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  },
  'c_changin_time_4': {
    title: '第三次变更时间',
    type: 'date',
    equation: all,
    width: 200,
    formatter: ({ cellValue }) => formatSapTime(cellValue)
  },
  'c_zzfld000016_5': {
    title: '第四次变更客户类型编码',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'c_zzfld000016_text_5': {
    title: '第四次变更客户类型描述',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'c_changin_date_5': {
    title: '第四次变更日期',
    type: 'date',
    equation: all,
    width: 200,
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  },
  'c_changin_time_5': {
    title: '第四次变更时间',
    type: 'date',
    equation: all,
    width: 200,
    formatter: ({ cellValue }) => formatSapTime(cellValue)
  }
}



// WEBPACK FOOTER //
// ./src/views/client-manage/config/customerTypeChange.js